import React from 'react';

const StoreIcon = () => {
  return (
    <div>
      <div className="relative mt-[350px] xl:max-w-[1430px] mx-14 xl:mx-14 lg:mx-14 md:mx-14 sm:mx-10">
        <div className="absolute bottom-0 left-0 mb-20">
          <p dir="ltr" className="text-center xl:text-3xl lg:text-2xl md:text-2xl sm:text-xl mb-8">Coming Soon On</p>
          <img src="assets/images/storeicon.svg" className=''/>
        </div>
      </div>
    </div> 
  )
}

export default StoreIcon;